module.exports = __webpack_public_path__ + "494cd07c/img/mini-logo.18817ee5.svg";